import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NavbarTop from '../../components/NavbarTop';
import {
  buildGamePixGameUrl,
  formatGamePixTitle,
  normalizeGamePixNamespace,
} from '../../utils/gamepix';
import './style.css';

interface GameLocationState {
  title?: string;
}

const Game = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const namespace = normalizeGamePixNamespace(id);
  const gameUrl = namespace ? buildGamePixGameUrl(namespace) : null;
  const state = location.state as GameLocationState | null;
  const title =
    state?.title?.trim() ||
    (namespace ? formatGamePixTitle(namespace) : 'Jogo');

  if (!namespace || !gameUrl) {
    return (
      <div className="game-player-page">
        <NavbarTop title="Paçoca Games" />
        <div className="game-player-error" role="alert">
          <h1>Jogo não encontrado</h1>
          <p>O endereço desse jogo não é válido.</p>
          <button type="button" onClick={() => navigate('/jogos')}>
            Voltar para os jogos
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="game-player-page">
      <Helmet>
        <title>{title} - Paçoca Games</title>
        <meta name="description" content={`Jogue ${title} no Paçoca Games.`} />
      </Helmet>

      <NavbarTop title={title} />

      <div className="game-player-shell">
        {loading ? (
          <div className="game-player-loading" role="status">
            <span aria-hidden="true" />
            Carregando {title}...
          </div>
        ) : null}
        <iframe
          className="game-player-frame"
          src={gameUrl}
          title={title}
          allow="autoplay; fullscreen; gamepad; clipboard-read; clipboard-write"
          allowFullScreen
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );
};

export default Game;
